<template>
  <div class="custom-header" ref="custom-header">
    <van-nav-bar :title="titleName" v-if="showNav && false" placeholder :border="false" @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="18" color="#333" />
      </template>

    </van-nav-bar>
    <!--  :style="{ position: showUser ? 'fixed' : 'relative', left: 0, top: 0 }" -->
    <div class="header" :class="{ grayBg: plat == '205' }">
      <img :src="$store.state.plat.logo" @click="toPage('./index')" />
      <div class="search" @click="goSearch">
        <img class="icon" src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/search_icon.png"
          alt="" />
        <span>搜索您感兴趣的内容</span>
      </div>
      <div class="user-center" v-if="isLogin" @click="toPage('./userYingyou/setting')">
        <!-- <p>个人</p>
        <p>中心</p> -->
        <img :src="userImg" />
      </div>

      <div class="user-center" v-else @click="toPage('./login/phone')">
        <!-- 登录/注册 -->
        <img :src="userImg" />
      </div>

    </div>
    <div class="index-tab-header" id="tab" v-if="showNav && tabShow">
      <van-tabs color="#000000" title-inactive-color="#999999" title-active-colo="#000" line-width="16"
        v-model="activeName" :ellipsis="false" :before-change="onChange">
        <van-tab :title="item.category_name" v-for="(item, index) of indexTab" :key="index"></van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showUser: {
      type: Boolean,
    },
    showNav: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      tabShow: false,
      userImg: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83.png',
      indexTab: [{
        category_name: ' 推荐',
        url: './index',
      }, {
        category_name: ' 育儿专家课堂',
        category_id: 217,
      }, {
        category_name: ' 育儿百科系列',
        category_id: 218,
      }],

    };
  },
  mounted() {
    console.log()
    this.$store.commit("SET_HEADER_HEIGHT", this.$refs['custom-header'].offsetHeight);
    this.getCat()


  },
  computed: {
    isLogin() {
      return this.$store.state.token ? true : false
    },
    activeName: {
      get() {
        return this.$store.state.headerActive;
      },
      set(value) {
        return this.$store.headerActive;
      },
    },
    titleName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },
  },
  methods: {
    getCat() {

      this.$request.tuoyuCategory2({ flat_id: this.plat }).then((res) => {
        if (this.plat == '121') {
          // this.indexTab.splice(1,1,...res.data)
          this.indexTab = [{
            category_name: ' 推荐',
            url: './index',
          }, {
            category_name: ' 育儿专家课堂',
            category_id: 217,
          }, {
            category_name: ' 育儿百科系列',
            category_id: 218,
          }
            , {
            category_name: ' 育儿宝库',
            category_id: 219
          }
            // ,{
            //   category_name:' 直播',
            //   url: './live',
            // }
          ]
          // 衡水项目新增需求
          if (sessionStorage.getItem('isHengShui') == '1') {
            this.indexTab.push({
              category_name: '宣传科普',
              url: './publicize',
            })
          }
        } else {
          this.indexTab.splice(2, 0, ...res.data.filter(v => v.category_id != '208' && v.category_id != '219' && v.category_id != '207' && v.category_id != '238' && v.category_id != '239' && v.category_id != '227' && v.category_id != '228'))
        }

        let r = this.$route;
        let activeName = ''
        if (this.$route.query.id && !this.$route.path.includes('lessonYingyouZT')) {
          activeName = this.indexTab.findIndex(item => item.category_id && item.category_id == this.$route.query.id)
        } else if (this.$route.path.includes('lessonYingyouZT')) {
          activeName = this.indexTab.findIndex(item => item.category_id && item.category_id == 1)
        } else {
          activeName = this.indexTab.findIndex(item => item.url && item.url.indexOf(this.$route.path.split('/').pop()) != -1)
        }
        this.$store.commit("SET_HEADER", activeName);
        this.tabShow = true
        this.$nextTick(() => {
          console.log(this.$refs['custom-header'].offsetHeight)
          this.$store.commit("SET_HEADER_HEIGHT", this.$refs['custom-header'].offsetHeight);

        })

      });
    },
    toPage(url) {
      this.$router.push(url);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    goSearch() {
      this.$router.push(`./SearchYingyou`);
    },
    onChange(name) {
      this.$store.commit("SET_HEADER", name);
      if (this.indexTab[name].url) {
        if (this.indexTab[name].url.indexOf('http') > -1) {
          window.open(this.indexTab[name].url)
        } else {
          this.$router.push(this.indexTab[name].url);
        }

      } else {
        if (this.indexTab[name].category_id == 237) {
          this.$router.push(`./lessonYingyouZT`);
        } else {
          this.$router.push(`./lessonYingyou?id=${this.indexTab[name].category_id}`);
        }

      }
      // this.$router.push(`./${name}`);
      return false;
    },
  },
  watch: {
    $route(newval, oldval) {
      console.log("this.$store.state", newval, oldval, this.$store.state.headerActive);

      this.$store.commit("SET_HEADER_HEIGHT", this.$refs['custom-header'].offsetHeight);

    },
  },
};
</script>

<style scoped lang="scss">
.index-tab-header {
  /* top: 96px; */

  border-bottom: 1px solid #000;
}

.custom-header {
  width: 100%;
  overflow: hidden;
  background: #fff;
  position: relative;
  z-index: 999;
  /* height: 90px; */
  position: fixed;
  left: 0;
  top: 0;
}

.grayBg {
  background-color: #F9F9F9 !important;
}

.header {
  width: 100vw;
  height: 96px;
  display: flex;
  align-items: center;
  background: #fff;
  z-index: 99;

}

.header>img {
  margin-left: 30px;
  width: 240px;
}

.search {
  flex: 1;
  border-radius: 33px;
  height: 66px;
  background: #f0f2f8;
  font-size: 28px;
  font-weight: 400;
  color: #9fa2b3;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30px;
}

.icon {
  width: 31px;
  height: 31px;
  margin-right: 20px;
}

.user-center {
  // flex: 0 0 118px;
  // width: 118px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #555;
  font-size: 26px;
  line-height: 30px;
  padding: 0 20px;

  img {
    width: 50px;
    height: 50px;
  }
}
</style>>